import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

/**
 * Pulsante globale "← Home" in alto a sinistra.
 * Appare su tutte le pagine TRANNE home ("/") e servizi ("/servizi").
 * Si nasconde automaticamente dove è già presente la Navbar
 * (il logo in alto a sinistra fa già da ritorno home), per evitare doppioni.
 */
export default function BackToHome() {
  const { pathname } = useLocation();
  const [hasHeader, setHasHeader] = useState(true);

  useEffect(() => {
    let n = 0;
    const check = () => setHasHeader(!!document.querySelector('[data-testid="site-header"]'));
    check();
    const iv = setInterval(() => { check(); if (++n > 14) clearInterval(iv); }, 200);
    return () => clearInterval(iv);
  }, [pathname]);

  if (pathname === "/" || pathname === "/servizi" || hasHeader) return null;

  return (
    <Link
      to="/"
      data-testid="back-to-home"
      aria-label="Torna alla home"
      className="fixed top-3 left-3 z-[70] inline-flex items-center gap-1.5 h-10 pl-2.5 pr-3.5 rounded-full font-bold text-[14px]"
      style={{
        background: "rgba(17,19,24,0.78)",
        color: "#FFFFFF",
        WebkitTextFillColor: "#FFFFFF",
        backdropFilter: "blur(10px)",
        WebkitBackdropFilter: "blur(10px)",
        border: "1px solid rgba(255,255,255,0.14)",
        boxShadow: "0 6px 20px -8px rgba(0,0,0,0.5)",
      }}
    >
      <ArrowLeft size={17} /> Home
    </Link>
  );
}
